export default __webpack_public_path__ + "static/media/info.f7dd15b5.svg";